import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Alert, Box, IconButton, Link, Slide, Typography } from '@mui/material';
import { useEventTracking } from '@services/statsig';
import { useAppDispatch } from '@store/hooks';

import { useActiveNotifications } from '../hooks';
import { dismissNotification } from '../store/slice';

export const SystemNotificationBanner: React.FC = () => {
  const dispatch = useAppDispatch();
  const { highestSeverityBanner } = useActiveNotifications();
  const { systemNotification } = useEventTracking();

  if (!highestSeverityBanner) return null;

  const handleDismiss = () => {
    systemNotification.bannerDismissed({
      notification_id: highestSeverityBanner.id,
      notification_type: 'banner',
      severity: highestSeverityBanner.severity,
      dismissal_type: highestSeverityBanner.persistent ? 'persistent' : 'session',
    });

    dispatch(
      dismissNotification({
        id: highestSeverityBanner.id,
        persistent: highestSeverityBanner.persistent,
      }),
    );
  };

  const handleLinkClick = () => {
    if (highestSeverityBanner.link) {
      systemNotification.linkClicked({
        notification_id: highestSeverityBanner.id,
        notification_type: 'banner',
        severity: highestSeverityBanner.severity,
        link_url: highestSeverityBanner.link.url,
        link_text: highestSeverityBanner.link.text,
      });
    }
  };

  return (
    <Slide direction="down" in mountOnEnter unmountOnExit>
      <Alert
        severity={highestSeverityBanner.severity}
        sx={{ borderRadius: 0 }}
        action={
          highestSeverityBanner.dismissible && (
            <IconButton
              aria-label="dismiss notification"
              size="small"
              onClick={handleDismiss}
              color="inherit"
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          )
        }
      >
        <Box>
          <Typography fontWeight="bold" component="span">
            {highestSeverityBanner.title}
          </Typography>
          <Typography variant="body2" component="span" sx={{ ml: 1 }}>
            {highestSeverityBanner.message}
          </Typography>
          {highestSeverityBanner.link && (
            <Link
              href={highestSeverityBanner.link.url}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ ml: 1 }}
              onClick={handleLinkClick}
            >
              {highestSeverityBanner.link.text}
            </Link>
          )}
        </Box>
      </Alert>
    </Slide>
  );
};
